import { useState, useEffect } from 'react';
import apiClient from '../Api/apiConfig'; // Votre configuration API
import '../styles/ActionsPage.css';

/**
 * 📌 Convertit une URL YouTube en URL d'intégration pour iframe.
 */
const convertYouTubeUrl = (url) => {
  const regex = /(?:youtube\.com\/watch\?v=|youtu\.be\/)([a-zA-Z0-9_-]+)/;
  const match = url.match(regex);
  return match ? `https://www.youtube.com/embed/${match[1]}` : url;
};

export default function ActionsPage() {
  const [actions, setActions] = useState([]);
  const [selectedAction, setSelectedAction] = useState(null);

  useEffect(() => {
    const fetchActions = async () => {
      try {
        const response = await apiClient.get('/api/actions'); // Appel à l'API
        setActions(response.data.map(action => ({ ...action, flipped: false }))); // Initialiser avec flipped à false
      } catch (err) {
        console.error('Erreur lors de la récupération des actions :', err.message);
      }
    };

    fetchActions();
  }, []);

  return (
    <div className="actions-page">
      <div className="actions-page__container">
        <header className="actions-page__header">
          <h1 className="actions-page__title">Nos Actions</h1>
          <p className="actions-page__subtitle">
            Découvrez nos actions concrètes pour améliorer la vie du quartier
          </p>
        </header>

        <div className="actions-page__grid">
          {actions.map((action) => (
            <div
              key={action.id}
              className={`actions-page__card ${action.flipped ? 'flipped' : ''}`}
              onMouseEnter={() => setActions(prev => prev.map(a => a.id === action.id ? { ...a, flipped: true } : a))}
              onMouseLeave={() => setActions(prev => prev.map(a => a.id === action.id ? { ...a, flipped: false } : a))}
            >
              <div className="actions-page__card-inner">
                {/* Face avant */}
                <div className="actions-page__card-front">
                  {action.type === 'image' && action.media_url && (
                    <div className="actions-page__media">
                      <img src={action.media_url} alt={action.title} />
                    </div>
                  )}
                  {action.type === 'video' && action.media_url && (
                    <div className="actions-page__media actions-page__media--video">
                      <iframe
                        width="100%"
                        height="200"
                        src={convertYouTubeUrl(action.media_url)}
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                        title={action.title}
                      />
                    </div>
                  )}
                  <h3 className="actions-page__action-title">{action.title}</h3>
                  <p className="actions-page__summary">
                    {action.description.substring(0, 100)}...
                  </p>
                </div>

                {/* Face arrière */}
                <div className="actions-page__card-back">
                  <p className="actions-page__description" style={{ color: 'white' }}>
                    {action.description.substring(0, 150)}...
                  </p>
                  <button 
                    className="actions-page__details-btn"
                    onClick={() => setSelectedAction(action)}
                  >
                    Voir plus
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      
      {/* Modal Popup */}
      {selectedAction && (
        <div className="modal-overlay" onClick={() => setSelectedAction(null)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <h2 style={{ color: 'white' }}>{selectedAction.title}</h2>
            <p style={{ color: 'white' }}>{selectedAction.description}</p>
            <button onClick={() => setSelectedAction(null)}>Fermer</button>
          </div>
        </div>
      )}
    </div>
  );
}